import { render, staticRenderFns } from "./Accordion-item.vue?vue&type=template&id=c899ed78&scoped=true&"
import script from "./Accordion-item.vue?vue&type=script&lang=js&"
export * from "./Accordion-item.vue?vue&type=script&lang=js&"
import style0 from "./Accordion-item.vue?vue&type=style&index=0&id=c899ed78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c899ed78",
  null
  
)

export default component.exports